// Sip Alchemy — Curated, verified product image URLs.
//
// Rules:
//   • Each URL points to a specific bottle image on Wikimedia Commons that
//     matches the exact product and brand (verified manually).
//   • Never map a product ID to another brand's bottle.
//   • For products without a verified image, leave them out of this map —
//     the <DrinkImage/> component will render a per-product branded fallback
//     with the actual product name + "Image unavailable" label.
//
// URL pattern uses Wikimedia's Special:FilePath which redirects to the
// canonical thumbnail; ?width=600 keeps payloads reasonable.
const wm = (filename) =>
  `https://commons.wikimedia.org/wiki/Special:FilePath/${filename}?width=600`;

// Keyed by the item `id` in /app/frontend/src/data/spirits.js
export const PRODUCT_IMAGES = {
  // ---------------- Whisky (w*) ----------------
  w1: wm("Bottle_of_Glenfiddich_12yo.jpg"),                          // Glenfiddich 12
  w2: wm("A_Bottle_of_Glenlivet_Scotch_Whiskey.jpg"),                // Glenlivet 12
  w3: wm("Talisker_Single_Malt_Scotch_Whisky_10_years_old.jpg"),     // Talisker 10
  w4: wm("Lagavulin_Single_Islay_Malt_16.jpg"),                      // Lagavulin 16
  w5: wm("Ardbeg_10_years_old_whisky.jpg"),                          // Ardbeg 10
  w6: wm("Bottle_of_Highland_Park_Single_Malt_12y_(2).JPG"),         // Highland Park 12
  w7: wm("Macallan_Amber_Scotch_whisky.jpg"),                        // Macallan (Amber shown as representative Macallan bottle)
  w8: wm("Bottle_of_Glenmorangie_10yo.jpg"),                         // Glenmorangie Original 10
  w9: wm("Johnnie_Walker_Black_Label.jpg"),                          // Johnnie Walker Black Label 12
  w10: wm("Chivas_Regal.jpg"),                                       // Chivas Regal 12
  w11: wm("Jameson_Original.jpg"),                                   // Jameson Original
  w14: wm("Jack_Daniels_bottle.jpg"),                                // Jack Daniel's Old No.7
  w15: wm("Jim_Beam_Bourbon_PL.JPG"),                                // Jim Beam White
  w16: wm("Bottle_of_Maker%27s_Mark_Whisky.JPG"),                    // Maker's Mark
  w18: wm("WildTurkeyBottle_no1.jpg"),                               // Wild Turkey 101
  w22: wm("Hibiki_the_premium_blended_whisky_from_Japanese_distiller_Suntory.jpg"), // Hibiki Japanese Harmony
  w23: wm("Nikka_Whisky_From_the_Barrel%2C_Japan.jpg"),              // Nikka From The Barrel
  w24: wm("A_50ml_bottle_of_Amrut_Fusion_single_malt_whisky.jpg"),   // Amrut Fusion
  w26: wm("Bold_Single_Malt_Whisky_from_Paul_John.png"),             // Paul John Bold

  // ---------------- Wine (wn*) ----------------
  wn14: wm("Champagne_Bollinger_007.jpg"),                           // Bollinger Special Cuvée (007 edition — same Special Cuvée)
  wn15: wm("Champagne_Ruinart_2005_(6711026347).jpg"),               // Ruinart Blanc de Blancs (same signature bottle)
  wn20: wm("Yellowtail.jpg"),                                        // Yellow Tail Shiraz
  wn21: wm("Casillero_del_Diablo_wine.jpg"),                         // Casillero del Diablo Cabernet
  wn26: wm("Sandeman_Port_2.jpg"),                                   // Sandeman 10 Year Tawny Port

  // ---------------- Beer (b*) ----------------
  b1:  wm("Bira_91_White_beer_bottle.jpg"),                          // Bira 91 White
  b4:  wm("Kingfisher_beer_bottle.jpg"),                             // Kingfisher Premium
  b12: wm("Corona_Extra_bottle.jpg"),                                // Corona Extra
  b13: wm("Heineken_Bottle.JPG"),                                    // Heineken
  b14: wm("Stella_Artois_bottle.jpg"),                               // Stella Artois
  b15: wm("Budweiser_Bottle.jpg"),                                   // Budweiser
  b18: wm("Bottiglia_di_birra_Nastro_Azzurro_Export.JPG"),           // Peroni Nastro Azzurro
  b19: wm("Asahi_beer_bottle.jpg"),                                  // Asahi Super Dry
  b20: wm("A_Bottle_of_Sapporo_Beer.jpg"),                           // Sapporo Premium
  b21: wm("Hoegaarden_bottle.JPG"),                                  // Hoegaarden
  b22: wm("Blue_Moon_Beer.jpg"),                                     // Blue Moon Belgian White
  b25: wm("Weihenstephaner_Hefe_Weissbier.JPG"),                     // Weihenstephaner Hefeweissbier
  b31: wm("Kronenbourg_1664.jpg"),                                   // Kronenbourg 1664

  // ---------------- Rum (r*) ----------------
  r1:  wm("Bacardi_Superior.jpg"),                                   // Bacardi Superior (White Rum)
  r4:  wm("2023_Havana_Club_A%C3%B1ejo_Especial_(3).jpg"),           // Havana Club Añejo (3 Años representative)
  r6:  wm("Captain_Morgan_Bottle.jpg"),                              // Captain Morgan Original Spiced
  r7:  wm("Kraken_rum.jpg"),                                         // Kraken Black Spiced Rum
  r9:  wm("Old_Monk_Rum.jpg"),                                       // Old Monk 7 Year
  r15: wm("Mount_Gay_Eclipse_Cocktails.JPG"),                        // Mount Gay Eclipse
  r17: wm("Appleton_Estate_V-X_Jamaica_Rum-front_shot.jpg"),         // Appleton Estate Signature (V-X is the same core expression)
  r25: wm("Sailor_Jerrys_bottle_unopened_with_clutter.jpg"),         // Sailor Jerry Spiced
};

export function getProductImage(id) {
  return PRODUCT_IMAGES[id] || "";
}
